module.exports = __webpack_public_path__ + "img/919-1a6a13.png";